import script from "./OwnerFieldOption.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerFieldOption.vue?vue&type=script&setup=true&lang=js"

import "./OwnerFieldOption.vue?vue&type=style&index=0&id=753d866e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-753d866e"]])

export default __exports__